import React from 'react';
import PropTypes from 'prop-types';

import './style';

const Footer = (props, context) => {
  const { theme: { textPrimary } } = context;
  return (
    <footer>
      <div className="content-grid">
        <div className="footer-note" style={{ color: textPrimary }}>
          <span>Made with <span role="img" aria-label="heart">❤️</span> by Danny</span>
          <span className="footer-divider" />
          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/d_nguyen_" style={{ color: textPrimary }}>
            <i className="fab fa-twitter" />
          </a>
          <span className="footer-divider" />
          <a target="_blank" rel="noopener noreferrer" href="https://buymeacoffee.com/kitsunebi" className="bmc-link" style={{ color: textPrimary }}>
            <i className="fas fa-coffee" />
            <span>Buy me a coffee</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

Footer.contextTypes = {
  theme: PropTypes.any,
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js